import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';

import { FeedbackFormComponent } from '@app/areas/crm/support-cases/components/feedback-form/feedback-form.component';
import { ModalComponent } from '@shared/components/modal/modal.component';
import { ModalService } from '@services/helpers/modal/modal.service';

@Component({
  selector: 'app-feedback-modal',
  standalone: true,
  imports: [CommonModule, ModalComponent, FeedbackFormComponent],
  templateUrl: './feedback-modal.component.html',
})
export class FeedbackModalComponent {
  private readonly modalService = inject(ModalService);

  onSubmitted(): void {
    this.modalService.close();
  }
}
